export default "__VITE_ASSET___szRAsHO__"